

































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Interview from "@/components/Interview.vue";
import InterviewCard from "@/components/InterviewCard.vue";
import { namespace } from "vuex-class";
const user = namespace("User");
@Component({
  components: {
    Interview,
    InterviewCard
  }
})
export default class Interviews extends Vue {
  @Prop({ default: "" })
  readonly oid!: string;
  @Prop({ default: null })
  readonly oportunity!: any;
  
  @user.State
  public id!: string;

  @Watch("oportunity")
  loggedInChanged(newVal: any) {
    if (newVal.id) {
      //this.$store.dispatch('bindInterviews', {oportunityId: this.oportunity.id, track: this.oportunity.name});
    }
  }
  get featuredInterview(): any {
    return this.oportunity.interview_featured;
  }
  get suggestedInterview(): any {
    return this.oportunity.interview_suggested;
  }
  get popularInterview(): any {
    return this.oportunity.interview_popular;
  }
  get interviews(): any[] {
    return this.oportunity.interviews;
    /*
    if (this.$store.state.interviews.length > 0) {
      return this.$store.state.interviews[0];
    } else {
      return null;
    }
    */
  }

  baseColors: string[] = [
    'orange-pastel',
    'red-pastel',
    'pink-pastel',
    'calypso-pastel'
  ];
  cardColor(color: string, index: number) {
    return color || this.baseColors[index % this.baseColors.length];
  }
}
